import type { MembershipRole } from 'src/types';
import { InviteeDetails } from '.';

type Props = {
  invitees: { email: string; role: MembershipRole }[];
  usersArePending: boolean;
  handleUpdateRole: (email: string, role: MembershipRole) => void;
  handleRemoveInvitee: (email: string) => void;
};

export const InviteesList = ({
  invitees,
  usersArePending,
  handleUpdateRole,
  handleRemoveInvitee,
}: Props) => {
  return (
    <div className='flex min-h-[160px] w-full flex-col items-center justify-start'>
      {usersArePending ? (
        ''
      ) : invitees.length === 0 ? (
        <span className='text-100 w-full text-left'>No Invitees Added Yet</span>
      ) : (
        <div className='flex w-full flex-col items-center justify-center gap-2'>
          {invitees.map((invitee, index) => (
            <InviteeDetails
              key={`${index}-invitee`}
              invitee={invitee}
              index={index}
              handleUpdateRole={handleUpdateRole}
              handleRemoveInvitee={handleRemoveInvitee}
            />
          ))}
        </div>
      )}
    </div>
  );
};
